<app-dropzone
  (onFileDrop)="dropped($event)"
  [imagePreviewSrc]="getImageSourceUrl()"
  [loading]="loading"
  (click)="removeFile()"
></app-dropzone>
